import { useState } from 'react';
import CountLink from './CountLink';
import StudentListDialog from './StudentListDialog';
import { STUDENT_KIND_LABEL, prefetchMauStudents } from './mauStudents';

// Makes a student-count column on the MAU page clickable and owns the popup:
//   const drill = useMauDrilldown(month);
//   { field: 'activeAsOfPeriodEnd', ..., render: drill.cell('active', 'activeAsOfPeriodEnd') }
//   ...
//   {drill.dialog}
const useMauDrilldown = (month) => {
  const [open, setOpen] = useState(null);
  const requestFor = (kind, row) => ({ kind, userId: row.entityId, userName: row.entityName, month });

  const cell = (kind, field) => (row) => (
    <CountLink
      count={row[field]}
      label={`${STUDENT_KIND_LABEL[kind].toLowerCase()} of ${row.entityName}`}
      onOpen={() => setOpen(requestFor(kind, row))}
      onPrefetch={() => prefetchMauStudents(requestFor(kind, row))}
    />
  );

  const dialog = open ? <StudentListDialog request={open} onClose={() => setOpen(null)} /> : null;
  return { cell, dialog };
};

export default useMauDrilldown;
